import api from '@/api';

import { API_BASE_URL } from '..';
import {
  ReportCustomersParams,
  ReportSuppliersParams,
  ReportModalEmployeeParams,
  InsurerReportFormValues,
  InsurerReportData,
  CustomersTagsRequest,
  CustomersTagsResponse,
  customerCsvData,
} from './Report.types';

const baseUrl = API_BASE_URL;

// People
export async function generateSuppliersReport(params?: ReportSuppliersParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/suppliers`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateCustomerVehiclesReport(customerId: number) {
  const result = (await api.getReport(
    `${baseUrl}/generate/customer/${customerId}/vehicles`,
    {},
  )) as unknown;

  return result as BlobPart;
}

export async function generateCustomersReport(params?: ReportCustomersParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/customers`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateCustomerCsvData(
  params?: Omit<ReportCustomersParams, 'format'>,
) {
  const result = (await api.get(
    `${baseUrl}/generate/customers-csv`,
    params,
  )) as unknown;

  return result as customerCsvData[];
}

export async function generateCustomersTags(params?: CustomersTagsRequest) {
  const result = (await api.get(
    `${baseUrl}/generate/customers/simplified`,
    params,
  )) as unknown;

  return result as CustomersTagsResponse[];
}

export async function generateEmployeesReport(
  params?: ReportModalEmployeeParams,
) {
  const result = (await api.getReport(
    `${baseUrl}/generate/employees`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateInsurerReport(params: InsurerReportFormValues) {
  const result = (await api.get(`${baseUrl}/insurers`, params)) as unknown;

  return result as BlobPart;
}

export async function generateInsurerDataReport(
  params: InsurerReportFormValues,
) {
  const result = (await api.get(
    `${baseUrl}/generate/insurers/data`,
    params,
  )) as unknown;

  return result as InsurerReportData[];
}
